import httpClient from "../../../../api/httpClient";
// eslint-disable-next-line no-unused-vars
import { convertDateToUTC, convertTimeToUTC } from "../utils/formatters"; // Must convert to UTC before sending, don't delete
import { API_BASE_URL } from "./contractApi.js";
import Cookies from "js-cookie";

const processRouteDates = (dto) => ({
  ...dto,
  ...(dto.startDate && { startDate: convertDateToUTC(dto.startDate) }),
  ...(dto.endDate && { endDate: convertDateToUTC(dto.endDate) }),
});

export const routeApi = {
  createRoute: (officeCode, routeDTO) =>
    httpClient.post(
      `${API_BASE_URL}/organizations/${officeCode}/routes`,
      processRouteDates(routeDTO)
    ),
  getRouteById: (officeCode, routeId) =>
    httpClient.get(`${API_BASE_URL}/organizations/${officeCode}/routes/${routeId}`),


   filterSingleOfficeCodeRoutes: (officeCode, criteria, pageable) => {
    const params = {
      page: pageable?.page || 0,
      size: pageable?.size || 15,
      sort: pageable?.sort || "id,asc",
    };
    return httpClient.post(
      `${API_BASE_URL}/organizations/${officeCode}/routes/filter`,
      criteria,
      { params }
    );
  },

  filterRoutes: (officeCode, criteria, pageable) => {
    const token = Cookies.get("authToken");
    const officeCodesCookie = Cookies.get("officeCodes");
    const officeCodes = officeCodesCookie ? officeCodesCookie.split(",") : [];
    //const officeCode = officeCodes[0];

    const params = {
      officeCodes: officeCodes.join(","),
      page: pageable?.page || 0,
      size: pageable?.size || 15,
      sort: pageable?.sort || "id,asc",
    };

    return httpClient.post(
      `${API_BASE_URL}/organizations/${officeCode}/routes/filter-for-multioffice`,
      criteria,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Office-Code": officeCode,
        },
        params,
        paramsSerializer: { indexes: null },
      }
    );
  },

  searchRoutes: (request, pageable) => {
    const token = Cookies.get("authToken");
    const officeCodesCookie = Cookies.get("officeCodes");
    const officeCodes = officeCodesCookie ? officeCodesCookie.split(",") : [];

    const params = {
      page: pageable?.page ?? 0,
      size: pageable?.size ?? 15,
      sortBy: pageable?.sortBy ?? "updatedAt",
      ascending: pageable?.ascending ?? false,
    };

    const criteria = {
      query: request?.query || "",
      status: "",
      // Nested AND/OR advanced-filter FilterNode tree (null/absent preserves the plain search)
      ...(request?.filter ? { filter: request.filter } : {}),
    };

    return httpClient.post(
      `${API_BASE_URL}/partial-details/route-search`,
      // `criteria` should match your `SearchRequest` shape (e.g., { query: "..." })
      criteria,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Spring will bind a comma-separated header into List<String>
          "Office-Code": officeCodes.join(","),
        },
        params,
        paramsSerializer: { indexes: null },
      }   
      );
    },

  updateRoute: (officeCode, routeId, routeDTO) =>
    httpClient.put(
      `${API_BASE_URL}/organizations/${officeCode}/routes/${routeId}`,
      processRouteDates({
        ...routeDTO,
        id: routeId,
      })
    ),
  deleteRoute: (officeCode, routeId) =>
    httpClient.delete(
      `${API_BASE_URL}/organizations/${officeCode}/routes/${routeId}`
    ),
};
